import React, { useImperativeHandle } from "react";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import CxTooltip from './CxTooltip';

const CxButton = props => {
  const { label, onClick, width, icon, iconPosition = "left", ...rest } = props;
  const [visible, setVisible] = React.useState(props.visible==='false' ? false : true);
  
  const rf_tooltip = React.useRef(null);

  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const doClick = (e) => {
    e.preventDefault();
    if (props.onClick) props.onClick(e);
  };

  useImperativeHandle(props.xref, () => ({
    getType,
    setVisible,
    getTooltip
  }));

  const getType = () => 'CxButton';
  const getTooltip = () => rf_tooltip.current;

  const renderContent = () => {
    if (!icon) return <span style={{ lineHeight: 1 }}>{label}</span>;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {iconPosition === "left" && icon}
        <span style={{ whiteSpace: "nowrap" }}>
          {label}
        </span>
        {iconPosition === "right" && icon}
      </div>
    );
  };

  return (
    <div style={{ display: visible ? '' : 'none' }}>
      <CxTooltip xref={rf_tooltip} text={rest.tooltip || null}>
        <button
          className={rest.className || "ibs_button"}
          style={{
            width: width || 'auto',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
          }}
          onClick={doClick}
          disabled={props.disabled}
          {...rest}
        >
          {renderContent()}
        </button>
      </CxTooltip>
    </div>
  );
};

export default CxButton;
